import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.splide__seo-cards' ).length ) {
        $( '.splide__seo-cards' ).each( function( index, element ) {
          const slider = new Splide( element, {
            type: 'loop',
            gap: '20px',
            fixedWidth: '350px',
            focus: 'center',
            perMove: 1,
            pagination: false,
            speed: 800,
            breakpoints: {
              768: {
                perPage: 1,
                gap: '1rem',
              },
            },
          } );
          slider.mount();
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'seo-cards', COMPONENT );
} )( app );
